<template>
  <div class="sci-layout" :class="{ 'is-mini-bg': useMiniBg }">
    <main class="sci-main">
      <router-view />
    </main>
    <footer class="sci-footer">
      <div class="sci-footer-text">
        <span class="sci-footer-item">鼓楼区教师进修学校© 2026 科创竞赛平台</span>
        <span class="sci-footer-divider">|</span>
        <span class="sci-footer-item">技术支持：福建数创联合科技有限公司</span>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'LayoutScienceInnovation',
  computed: {
    useMiniBg() {
      return [
        'scienceInnovationNews',
        'scienceInnovationNewsDetail',
        'scienceInnovationSignup',
        'scienceInnovationActivityDetail',
        'scienceInnovationRegister',
        'scienceInnovationJudge',
      ].includes(this.$route.name);
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/fonts/font.css';
</style>

<style lang="scss" scoped>
.sci-layout {
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f7fbff;
  background-image: url('~@/assets/scienceInnovation/kc-home-bg.png');
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 100% 100%;
  font-family: '普惠_2.0_medium', 'Microsoft YaHei', sans-serif;

  &.is-mini-bg {
    background-image: url('~@/assets/scienceInnovation/kc-home-bg-mini.png');
  }
}

.sci-main {
  flex: 1;
  width: 100%;
  position: relative;
}

.sci-footer {
  width: 100%;
  background: #eceff3;
  box-sizing: border-box;
  padding: 20px 110px;
  text-align: center;
}

.sci-footer-text {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px 12px;
  font-size: 13px;
  color: #666;
  line-height: 1.6;
}

.sci-footer-divider {
  color: #999;
}

@media (max-width: 1200px) {
  .sci-layout {
    background-image: url('~@/assets/scienceInnovation/kc-home-bg-mini.png');
  }

  .sci-footer {
    padding: 18px 40px;
  }

  .sci-footer-text {
    font-size: 12px;
  }
}

@media (max-width: 768px) {
  .sci-footer {
    padding: 16px;
  }

  .sci-footer-text {
    flex-direction: column;
    gap: 4px;
    font-size: 12px;
  }

  .sci-footer-divider {
    display: none;
  }
}

@media (max-width: 480px) {
  .sci-footer-text {
    font-size: 11px;
  }
}
</style>
